<template>
  <v-container class="d-flex1 align-center justify-center">
    <v-card
      class="d-flex align-center pa-0"
      rounded="pill"
      width="300"
      height="60"
      color="#eee"
    >
      <v-card-text
        class="ma-0 ps-10"
        style="font-family: tajawal; font-size: 14; font-weight: bold"
      >
        {{ $t(stat.key) }}
      </v-card-text>
      <v-btn
        class="ma-0 pa-0 rounded-s text-none"
        rounded
        height="100%"
        color="grey-lighten-1 text-yellow"
        style="font-family: tajawal; font-size: large; font-weight: bolder"
        >{{ stat.value }}</v-btn
      >
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "StatCard",
  props: { stat: Object },
};
</script>
